import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteMyMonitoringPushRegistration = async (pushId: string): Promise<boolean> =>
  axios.delete(`/PushRegistration/RemoveMyMonitoringRegistration?pushId=${pushId}`).then((res) => res?.data?.result)

type Props = {
  pushId: string
}

export const useMyMonitoringDeletePushRegistration = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return false
      }

      return true
    },
    mutationKey: ['deleteMyMonitoringPushRegistration'],
    mutationFn: ({ pushId }: Props) => deleteMyMonitoringPushRegistration(pushId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Removed push registration.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to remove push registration.')
      }
    },
    throwOnError: false
  })
